module.exports = __webpack_public_path__ + "static/img/dd_order.5a7f9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/dd_order.png
// module id = 1754
// module chunks = 0